import { axios } from '../../utilities/axiosClient'
import { CategoryAndArea } from '../../types/Voucher'

/**
 * voucherSearchで使用する検索アイテムを取得するためのAPI
 */
export const getVoucherCategoryAndArea = (): Promise<CategoryAndArea> =>
  axios.get('/api/coupon')
